import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-dept-whitelist-dialog',
  template: `
    <div style="min-width: 360px;">
      <h2 mat-dialog-title style="color: #3f51b5; font-weight: 600; margin-bottom: 4px;">
        <mat-icon style="vertical-align: middle; margin-right: 8px;">
          {{data.modo === 'crear' ? 'add_circle' : 'edit'}}
        </mat-icon>
        {{data.modo === 'crear' ? 'Agregar Box' : 'Editar Box'}}
      </h2>

      <mat-dialog-content>
        <form [formGroup]="form" fxLayout="column" fxLayoutGap="8px">
          <mat-form-field appearance="outline">
            <mat-label>Codigo de Box</mat-label>
            <input matInput formControlName="department_code"
              style="text-transform: uppercase; font-weight: 600; letter-spacing: 1px;"
              autocomplete="off" maxlength="20" placeholder="Ej: COMC">
            <mat-icon matSuffix style="color: #999;">label</mat-icon>
            <mat-error *ngIf="form.controls.department_code.hasError('required')">Campo requerido</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Descripcion (opcional)</mat-label>
            <input matInput formControlName="descripcion"
              autocomplete="off" maxlength="100" placeholder="Ej: Departamento Comercial">
            <mat-icon matSuffix style="color: #999;">description</mat-icon>
          </mat-form-field>
        </form>
      </mat-dialog-content>

      <mat-dialog-actions align="end" style="padding-top: 8px;">
        <button mat-button (click)="onCancel()" style="color: #666;">Cancelar</button>
        <button mat-raised-button color="primary" [disabled]="!form.valid" (click)="onSave()"
          style="border-radius: 8px;">
          <mat-icon style="font-size: 18px; margin-right: 4px;">{{data.modo === 'crear' ? 'add' : 'save'}}</mat-icon>
          {{data.modo === 'crear' ? 'Agregar' : 'Guardar'}}
        </button>
      </mat-dialog-actions>
    </div>
  `
})
export class DeptWhitelistDialogComponent {

  form = new FormGroup({
    department_code: new FormControl(this.data.department_code || '', [Validators.required]),
    descripcion: new FormControl(this.data.descripcion || '')
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DeptWhitelistDialogComponent>
  ) { }

  onCancel() {
    this.dialogRef.close(null);
  }

  onSave() {
    if (this.form.valid) {
      this.dialogRef.close({
        department_code: this.form.controls.department_code.value.trim().toUpperCase(),
        descripcion: this.form.controls.descripcion.value ? this.form.controls.descripcion.value.trim() : null
      });
    }
  }
}
